import { axios, Response } from '../index'

export interface GetClinicChecklistsResponse {
  id: string
  title: string
  companyOrUserEntity: CompanyOrUserEntity
  favoritesChecklistItemsResponse: GetFavoriteChecklistItemResponse[]
  creatorInfos: PersonaInfoSummary
  createdDate: string
}

interface GetFavoriteChecklistItemResponse {
  id: string
  title: string
  favoriteChecklistId: string
}

interface PersonaInfoSummary {
  userId: string
  username: string
  avatarUrl: string
}

enum CompanyOrUserEntity {
  COMPANY = 'COMPANY',
  USER = 'USER'
}

const getClinicChecklists = (): Response<GetClinicChecklistsResponse[]> => {
  return axios.get(`/v1/favorites/favorites-checklists`)
}

export default getClinicChecklists
